import React, { useEffect } from "react";

const ToggleSwitch = ({ isOn, onToggle }) => {
    const [initialState, setInitialState] = React.useState(isOn);
	const [isHovered, setIsHovered] = React.useState(false);
    const [lockHover, setLockHover] = React.useState(false);
	const title = isOn ? "Toggle off" : "Toggle on";

	const activationClass = isOn ? "" : "toggled-off";    
    const lockHoverClass = lockHover ? "hover-lock" : "";
	const buttonClass = activationClass + " toggle-switch " + lockHoverClass;

    useEffect(() => {
        if (initialState !== isOn) {
            setLockHover(true); 
            setInitialState(isOn);
        }
    }, [isOn, isHovered, initialState]);

	return (
		<button
			onMouseEnter={() => {setIsHovered(true); setLockHover(false);}}
			onMouseLeave={() => {setIsHovered(false); setLockHover(false);}}
            onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();                
                setLockHover(true);
                onToggle(); 
            }}
			className={buttonClass}
			title={title}>
			<div className={`${isHovered && !lockHover && "middle-state"} ${lockHover && "hover-lock"}`}></div>
		</button>
	);
};

export default ToggleSwitch;
